import type { MedicationConfigOverride } from '../hooks/use-config-api';
import { DrugKeys } from '../util/config/constants';

import { emgalityProducts } from './emgality';
import { foundayoProducts } from './foundayo';
import { mounjaroProducts } from './mounjaro';
import { insulinProducts } from './other/insulin';
import { pharmacyOverrides } from './pharmacies';
import {
    type MedicationProduct,
    buildNdcInfo,
    buildNdcSwitchConfigs,
    buildStaticPricing,
    buildNdcSwitchV2Configs,
    buildNdcHoldConfigs,
    buildNdcDisclosureConfigs,
} from './shared';
import { trulicityProducts } from './trulicity';
import { zepboundAutoInjectors } from './zepbound/autoinjector';
import { zepboundKwikpens } from './zepbound/kwikpen';
import { zepboundVials } from './zepbound/vial';

const allProducts: MedicationProduct[] = [
    ...zepboundAutoInjectors,
    ...zepboundVials,
    ...zepboundKwikpens,
    ...foundayoProducts,
    ...trulicityProducts,
    ...emgalityProducts,
    ...mounjaroProducts,
];

const localConfig: MedicationConfigOverride = {
    ndcInfo: buildNdcInfo([...allProducts, ...insulinProducts]),
    drugNames: {
        [DrugKeys.Emgality]: 'Emgality®',
        [DrugKeys.Mounjaro]: 'Mounjaro®',
        [DrugKeys.Orfo]: 'Foundayo™',
        [DrugKeys.Trulicity]: 'Trulicity®',
        [DrugKeys.ZepboundAutoinjector]: 'Zepbound®',
        [DrugKeys.ZepboundKwikPen]: 'Zepbound®',
        [DrugKeys.ZepboundVial]: 'Zepbound®',
    },
    staticPricing: buildStaticPricing(allProducts),
    constants: {
        LILLY_DIRECT_URL: 'https://lilly.com/lillydirect/',
        LILLY_SAFETY_URL: 'https://zepbound.lilly.com/risk',
        OURA_SIZING_KIT_URL: 'https://lilly.com/lillydirect/oura',
        PARTNER_NAME: 'LillyDirect',
    },
    pharmacyOverrides,
    ndcSwitchConfigs: buildNdcSwitchConfigs(allProducts),
    ndcSwitchConfigsV2: buildNdcSwitchV2Configs(allProducts),
    ndcHoldConfigs: buildNdcHoldConfigs(allProducts),
    ndcDisclosureConfigs: buildNdcDisclosureConfigs(allProducts),
};

export default localConfig;
